import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    base_amount: PropTypes.number,
    formattedValue: PropTypes.string,
    criteria: PropTypes.number
  })
);



// WEBPACK FOOTER //
// ./src/model/Types/discounts.js